import React, { FC } from 'react'
import { graphql } from 'gatsby'

import { PostsListQueryQuery } from '@graphqlTypes'

import Cards from "@components/Cards/Cards"
import DefaultPrefooter from "@components/prefooters/DefaultPrefooter/DefaultPrefooter"
import SEO from "@components/SEO/SEO"

import PostsHero from "../components/PostsHero/PostsHero"

type PostsListProps = {
  data: PostsListQueryQuery
  pageContext: {
    permalink: string
    subcategorySlug?: string
  }
}

export const Head: FC<PostsListProps> = ({
  data: {
    category,
  },
  pageContext: {
    permalink,
  },
}) => (
  <SEO
    description={category?.seoDescription || ""}
    image={category?.seoImage?.imgixImage?.url || ""}
    permalink={permalink}
    title={category?.seoTitle || category?.title || ""}
  />
)

const PostsList: FC<PostsListProps> = ({
  data: {
    category,
    allCategoriesData: { nodes: allCategories },
    allPostsAndLps,
  },
  pageContext: {
    subcategorySlug,
  },
}) => {
  return (
    <>
      <PostsHero
        allCategories={allCategories}
        categoryPermalink={category?.permalink}
        categorySlug={category?.slug}
        currentTopicSlug={subcategorySlug}
        title={category?.title}
        topics={category?.subcategories}
      />
      <section className="padding-bottom--L">
        <div className="container">
          {allPostsAndLps && (
            <Cards
              items={allPostsAndLps}
              showSubcategory
              title={category?.slug === 'all' ? "All Posts" : undefined}
            />
          )}
        </div>
      </section>
      <DefaultPrefooter />
    </>
  )
}

export const pageQuery = graphql`
  query PostsListQuery(
    $categoryId: String!
    $subcategoryId: String
  ) {
    category: contentfulPostCategory(contentful_id: {eq: $categoryId}) {
      id
      permalink
      subcategories {
        ...PostSubCategoryFragment
      }
      seoTitle
      seoImage {
        imgixImage {
          url
        }
      }
      slug
      title
      seoDescription
    }
    allCategoriesData: allContentfulPostCategory(
      sort: {title: ASC}
    ) {
      nodes {
        ...PostCategoryFragment
      }
    }
    allPostsAndLps: allPostsAndLandingPages(
      categoryId: $categoryId
      subcategoryId: $subcategoryId
    ) {
      ...CardPostOrLpFragment
    }
  }
`

export default PostsList